import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { defaultPage, defaultPageSize } from './constants'

const usePackaging = ({ storeId }) => {
  const { data, loading: fetchingPackaging } = useFetch(
    () => configurationServices.getPackaging({ storeId, page: defaultPage, pageSize: defaultPageSize }),
    {
      doInitialRequest: !!storeId,
    }
  )

  return {
    packaging: data?.results || [],
    fetchingPackaging,
  }
}

export default usePackaging
